import * as React from "react";
function SvgTw(props) {
  return (
    <svg
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.293 2.026c-.44.147-.878.293-1.317.293.146 0 .439-.439.585-.585.146-.293.293-.44.439-.732V.856h-.146c-.44.292-1.025.439-1.464.585h-.146l-.146-.146c-.293-.147-.44-.293-.732-.44C10.073.71 9.634.71 9.196.71c-.44 0-.733.147-1.025.293-.293.146-.586.439-.878.732-.293.292-.44.585-.44 1.024a1.25 1.25 0 000 1.024s0 .147 0 0C4.806 3.49 3.05 2.758 1.733 1.148c0-.146-.147-.146-.147 0-.585.878-.292 2.342.44 3.073l.292.293s-.585 0-1.024-.293h-.147v.293c.147.878.732 1.756 1.61 2.049.146 0 .293.146.293.146-.147 0-.44.147-1.025 0-.146 0-.146 0-.146.147.44 1.17 1.317 1.463 2.049 1.756h.292c-.292.292-1.024.585-1.463.731-.732.293-1.463.293-2.195.293H.415v.146c.146.147.292.147.439.293.439.293.878.44 1.463.586 2.634.731 5.561.146 7.463-1.757 1.464-1.463 2.05-3.512 2.05-5.56 0-.147.146-.147.146-.147A3.42 3.42 0 0013 2.173c.293 0 .293-.147.293-.147z"
        fill="#fff"
      />
    </svg>
  );
}
export default SvgTw;
